import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import CustomPagination from "../../Component/Common/CustomPagination";
import ConfirmModal from "../../Component/Common/ConstomModal/ConfirmModal";
import { CustomReactTable } from "../../Component/Common/CustomReactTable";
import SwitchField from "../../Component/Common/SwitchField";
import { InputField } from "../../Component/Common/InputField";
import { Tabs } from "../../Component/Common/Tabs";
import EditIcon from "../../../image/Group15.png";
import DeleteIcon from "../../../image/deleteIcon1.png";
import { FaUserCircle } from "react-icons/fa";
import useDebounce from "../../helper/customhook";
import { handleKeyDown, orderTabList, ROLE, canEditUserRecord, canDeleteUserRecord } from "../../helper";
import { getStorage } from "../../helper/storage";
import { getAllOrder, deleteOrder, updateActiveOrder } from "../../services/orderService";

const column = [
  { Header: "Profile Image", accessor: "profile_image" },
  { Header: "App Name", accessor: "app_name" },
  { Header: "Assembly Number", accessor: "assembly_number" },
  { Header: "Mobile Numner", accessor: "mobile_number" },
  { Header: "Party Name", accessor: "party_name" },
  { Header: "Username", accessor: "username" },
  { Header: "Action", accessor: "action" },
];

// User Management list ("User List" in the old sidebar, Orders.js). RBAC
// here deliberately stays on the ROLE/canEditUserRecord/canDeleteUserRecord
// pattern (not FEATURES/hasAccess) - a separate, pre-existing mechanism
// documented in roles.config.js, left untouched per the restructure's "don't
// flatten the permission logic" instruction.
export const UserList = () => {
  const navigate = useNavigate();
  const userLogin = getStorage("logged-in");
  const queryClient = useQueryClient();

  const obj = { offset: 0, currentPage: 0, search: "", ordering: "-id" };
  const [status] = useState(1);
  const [filter, setFilter] = useState({
    limit: 17,
    status,
    app_name: userLogin?.app_name,
    party_name: userLogin?.party_name,
    ...obj,
  });
  const [loaderForList, setLoaderForList] = useState(false);
  const [openDel, setOpenDel] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedValues] = useState([]);

  const debouncedFilter = useDebounce(filter, 500);

  const { data: dataList } = useQuery(
    ["getAllOrder", debouncedFilter],
    () => getAllOrder(debouncedFilter, filter),
    { enabled: Boolean(debouncedFilter), refetchOnWindowFocus: false }
  );

  useEffect(() => {
    setLoaderForList(!dataList);
  }, [dataList]);

  const updateActiveMutation = useMutation(updateActiveOrder, {
    onSuccess: (res) => {
      if (res?.success) {
        toast.success(res?.message || "success");
        queryClient.refetchQueries("getAllOrder");
      }
    },
  });

  const deleteMutation = useMutation(deleteOrder, {
    onSuccess: (res) => {
      if (res?.success) {
        toast.success(res?.message || "success");
        queryClient.refetchQueries("getAllOrder");
        setOpenDel(false);
      }
    },
  });

  const handleEditAction = (item) => {
    if (!canEditUserRecord(userLogin, item)) return;
    navigate(`/user-management/add?editId=${item.uuid}`);
  };

  const hendleDeleteTag = (data, flag) => {
    setOpenDel(flag);
    setDeleteId(data.uuid);
  };

  const rowDataList = (data) =>
    data?.map((item, i) => ({
      ...item,
      profile_image: item?.profile_image ? (
        <img
          src={item.profile_image}
          alt="Profile Preview"
          style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover" }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ) : (
        <FaUserCircle style={{ fontSize: 60, color: "#bdbdbd" }} />
      ),
      action: (
        <div className="actionBtn">
          <SwitchField
            size="sm"
            onSwitchChange={() => updateActiveMutation.mutate({ id: item.uuid, is_active: !item?.is_active })}
            value={item?.is_active}
            disabled={![ROLE.SUPER_ADMIN, ROLE.ADMIN].includes(Number(userLogin?.user_type))}
          />
          {canEditUserRecord(userLogin, item) && <img src={EditIcon} alt="" onClick={() => handleEditAction(item)} />}
          {canDeleteUserRecord(userLogin, item) && (
            <img src={DeleteIcon} alt="" onClick={() => hendleDeleteTag(item, true)} />
          )}
        </div>
      ),
    }));

  const handlePageClick = (data) => {
    const currentPage = data.selected;
    setFilter((s) => ({ ...s, offset: currentPage * filter.limit, currentPage }));
  };

  return (
    <>
      <div className="tabMain_head">
        {" "}
        <Tabs TabList={orderTabList} handleActive={() => {}} activeTab={filter.status} />
        {/* <div className="checkBox_Cnacle">
          {selectedValues.length > 0 && userLogin?.user_type === ROLE.SUPER_ADMIN && (
            <button className="addPlan" onClick={() => setOpenDel(true)}>
              Cancel Orders
            </button>
          )}
          {userLogin?.user_type !== ROLE.VIEWER && (
            <button className="addPlan" onClick={() => navigate("/user-management/add")}>
              Add Users
            </button>
          )}
        </div> */}
      </div>

      <div className="anvTask_prog">
        <div className="anvInputs&fillters">
          <div className="inr_flex_filter">
            <button className="filterBox">Filter</button>
          </div>
          <div className="inr_flex_mini ">
            <InputField
              placeholder="User Name"
              className="anvSearch_input"
              onChange={(e) => setFilter((s) => ({ ...s, ...obj, username: e.target.value }))}
            />
          </div>
          <div className="inr_flex_mini ">
            <InputField
              placeholder="Assembly Number"
              className="anvSearch_input"
              onChange={(e) => setFilter((s) => ({ ...s, ...obj, assembly_number: e.target.value }))}
            />
          </div>
          <div className="inr_flex_mini ">
            <InputField
              placeholder="Mobile Number"
              className="anvSearch_input"
              maxLength={10}
              onKeyDown={handleKeyDown}
              onChange={(e) => setFilter((s) => ({ ...s, ...obj, mobile_number: e.target.value }))}
            />
          </div>
        </div>
      </div>

      <div className="table table_hieght">
        <div className="table-responsive">
          <CustomReactTable
            columns={column}
            data={rowDataList(dataList?.results ? dataList?.results : [])}
            tableLoading={loaderForList}
          />
        </div>
      </div>
      {dataList?.results?.length > 0 && (
        <CustomPagination
          onPageChange={handlePageClick}
          currentPage={filter?.currentPage}
          pageCount={Math.ceil(dataList?.count / filter?.limit)}
        />
      )}

      <ConfirmModal isOpen={openDel} toggle={() => setOpenDel(!openDel)} onSubmit={() => deleteMutation.mutate(deleteId)} />
    </>
  );
};
